import axios from "axios";

export const apiClient = axios.create({
	baseURL: process.env.REACT_APP_PRODUCT_API_BASEADDRESS,
	headers: {
		"Content-Type": "application/json",
	},
	timeout: 30000,
});

export const createCustomer = (customer) => {
	return apiClient.post("customer/create", customer);
};

export const fetchProducts = () => {
	return apiClient.get("product");
};

export const fetchItemCategories = () => {
	return apiClient.get("product/categories");
};

export const fetchFields = () => {
	return apiClient.get("product/fields");
};

export const fetchUoms = () => {
	return apiClient.get("product/uoms");
};

export const fetchProductById = (productId) => {
	return apiClient.get("product/" + productId);
};

export const updateProductItem = (productId, product) => {
	return apiClient.put("product/item/" + productId, product);
};

export const updateProductCategory = (productCategoryId, productCategory) => {
	return apiClient.put(
		"product/category/" + productCategoryId,
		productCategory
	);
};

export const updateProductField = (productFieldId, productField) => {
	return apiClient.put("product/field/" + productFieldId, productField);
};

export const updateProductGroup = (productId, product) => {
	return apiClient.put("product/group/" + productId, product);
};

export const fetchQuotes = () => {
	return apiClient.get("quotes");
};

export const fetchQuoteTemplates = () => {
	return apiClient.get("quotes/templates");
};

export const updateQuoteTemplate = (templateId, template) => {
	return apiClient.put("quotes/templates/" + templateId, template);
};

export const fetchQuoteStatuses = () => {
	return apiClient.get("quotes/getQuoteStatuses");
};

export const fetchQuoteById = (quoteId) => {
	return apiClient.get("quotes/" + quoteId);
};

export const updateQuote = (quoteId, quote) => {
	return apiClient.put("quotes/" + quoteId, quote);
};

export const updateQuoteStatus = (quoteId, quote) => {
	return apiClient.patch(`quotes/${quoteId}/quotestatus`, quote);
};

export const createQuote = (quote) => {
	return apiClient.post("quotes/create", quote);
};

export const convertQuoteToJob = (quoteId, request) => {
	return apiClient.post(`quotes/${quoteId}/convertToJob`, request);
};

export const releaseJob = (quoteId, request) => {
	return apiClient.post(`quotes/${quoteId}/releaseJob`, request);
};

export const resubmitJob = (quoteId, request) => {
	return apiClient.post(`quotes/${quoteId}/resubmitJob`, request);
};

export const createProductItem = (product) => {
	return apiClient.post("product/item/create", product);
};

export const createProductGroup = (product) => {
	return apiClient.post("product/group/create", product);
};

export const fetchHistoryById = (id, entityType) => {
	return apiClient.get(`history?entityid=${id}&entitytype=${entityType}`);
};

export const fetchCustomerClients = () => {
	return apiClient.get("client");
};

export const fetchClientById = (id) => {
	return apiClient.get(`client/${id}`);
};

export const updateClient = (clientId, product) => {
	return apiClient.put("client/" + clientId, product);
};

export const createClient = (client) => {
	return apiClient.post("client/create", client);
};

export const removeProductField = (productFieldIds) => {
	return apiClient.delete("product/field", { data: productFieldIds });
};

export const removeProductCategories = (productCategoryIds) => {
	return apiClient.delete("product/category", { data: productCategoryIds });
};

export const removeQuoteTemplates = (templateIds) => {
	return apiClient.delete("quotes/templates", { data: templateIds });
};
